var _desc, _defs, _rect, _rect2, _text, _line, _g, _g2, _g3, _path, _path2, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliedIntelligenceFlowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 394",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Mobile friction-to-flow diagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "People, data and systems feed into an applied intelligence layer that creates better business flow.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#20C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "core"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#087CFF",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 26,
    height: 26,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26",
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.06,
    strokeWidth: 0.7
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 388,
    height: 392,
    rx: 22,
    fill: "#071225",
    stroke: "#4D607E",
    strokeOpacity: 0.72,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 364,
    height: 368,
    rx: 16,
    fill: "url(#grid)",
    stroke: "#8CA0BD",
    strokeOpacity: 0.16
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 42,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 760,
    letterSpacing: 2.2
  }, "FROM FRICTION TO FLOW")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 57,
    x2: 365,
    y2: 57,
    stroke: "#40516A",
    strokeOpacity: 0.65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 10,
    fill: "#0B1A31",
    stroke: "#49607E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 11,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 3,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27c1-4 3-5 5-5s4 1 5 5",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 25,
    fill: "#FFFFFF",
    fontSize: 11.5,
    fontWeight: 680
  }, "People")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145 74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 10,
    fill: "#0B1A31",
    stroke: "#49607E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 11,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16h10M16 20h10M16 24h10",
    stroke: "#087CFF",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 25,
    fill: "#FFFFFF",
    fontSize: 11.5,
    fontWeight: 680
  }, "Data")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264 74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 10,
    fill: "#0B1A31",
    stroke: "#49607E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 11,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 16-4 4 4 4M24 16l4 4-4 4",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 25,
    fill: "#FFFFFF",
    fontSize: 11.5,
    fontWeight: 680
  }, "Systems")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 114v18c0 20 62 16 82 47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 114v48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 114v18c0 20-62 16-82 47"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(195 210)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 94,
    fill: "url(#core)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 66,
    fill: "#061127",
    stroke: "#1E4067",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 58,
    fill: "none",
    stroke: "#173A61",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 58,
    fill: "none",
    stroke: "url(#flow)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "305 58",
    transform: "rotate(-88)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 77,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.31,
    strokeDasharray: "2 6"
  }), /*#__PURE__*/React.createElement("text", {
    y: -4,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760,
    textAnchor: "middle",
    letterSpacing: 0.8
  }, "APPLIED"), /*#__PURE__*/React.createElement("text", {
    y: 15,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760,
    textAnchor: "middle",
    letterSpacing: 0.8
  }, "INTELLIGENCE"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195 276v19",
    stroke: "url(#flow)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m189 290 6 7 6-7",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 300)",
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 42,
    rx: 13,
    fill: "#0D1D35",
    stroke: "#6A3B65",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 26,
    fill: "#FFFFFF",
    fontSize: 12.5,
    fontWeight: 760,
    textAnchor: "middle"
  }, "BETTER FLOW"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 351)",
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 29,
    rx: 9,
    fill: "#0A172B",
    stroke: "#3B506D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.5,
    r: 8,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 14 3 3 5-6",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 31,
    y: 18.5,
    fill: "#FFFFFF",
    fontSize: 9.5
  }, "Less friction \xB7 Faster decisions \xB7 Measurable productivity"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIntelligenceFlowMobile);
export default __webpack_public_path__ + "static/media/applied-intelligence-flow-mobile.0ec68e523fd2e6b0503c30763316011e.svg";
export { ForwardRef as ReactComponent };